import React, { useState, useEffect } from 'react';
import { getDatabase, ref, onValue, update } from 'firebase/database';
import './Messaging.css';

const MessageView = ({ messageId, onBack }) => {
    const [message, setMessage] = useState(null);
    const [loading, setLoading] = useState(true);
    const db = getDatabase();

    useEffect(() => {
        const messageRef = ref(db, `messages/${messageId}`);
        const unsubscribe = onValue(messageRef, (snapshot) => {
            if (snapshot.exists()) {
                const msgData = snapshot.val();
                setMessage({ id: snapshot.key, ...msgData });
                // Mark as read if it hasn't been already
                if (!msgData.isRead) {
                    update(messageRef, { isRead: true });
                }
            } else {
                setMessage(null);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, [messageId, db]);

    if (loading) {
        return <div className="message-view"><p>Loading message...</p></div>;
    }

    if (!message) {
        return <div className="message-view"><p>Message not found.</p></div>;
    }

    return (
        <div className="message-view">
            <div className="message-view-header">
                <button onClick={onBack} className="back-button">
                    <span className="material-icons">arrow_back</span>
                </button>
                <h2 className="message-subject-header">{message.subject}</h2>
            </div>
            <div className="message-details">
                <div className="message-sender-info">
                    <span className="sender-avatar">{message.fromName ? message.fromName.charAt(0).toUpperCase() : 'U'}</span>
                    <div>
                        <strong>{message.fromName}</strong>
                        <span className="sender-email">&lt;{message.from}&gt;</span>
                    </div>
                </div>
                <div className="message-date-header">{new Date(message.timestamp).toLocaleString()}</div>
            </div>
            <div className="message-body-content">
                <p>{message.body}</p>
            </div>
            <div className="message-actions">
                <button className="action-button">
                     <span className="material-icons">reply</span> Reply
                </button>
                 <button className="action-button">
                     <span className="material-icons">forward</span> Forward
                </button>
            </div>
        </div>
    );
};

export default MessageView;
